import { render, staticRenderFns } from "./FormWizardRegister.vue?vue&type=template&id=62c69fc9"
import script from "./FormWizardRegister.vue?vue&type=script&lang=js"
export * from "./FormWizardRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports